<template>
  <div class="card shadow">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Experiments</h3>
        </div>
        <div class="col text-right">
          <base-button type="success" size="sm" @click="showCreateModal()" icon="fa fa-plus">Add experiment</base-button>
        </div>
      </div>

      <base-alert type="success" class="mt-3" v-if="successMessage">
        The changes have been successfully saved.
      </base-alert>
    </div>

    <div class="table-responsive">
      <table class="table align-items-center table-flush">
          <thead class="thead-light">
            <tr>
              <th>Experiment</th>
              <th>Status</th>
              <th>Instrument</th>
              <th></th>
            </tr>
          </thead>
          <draggable v-model="items" 
              tag="tbody" 
              item-key="id" 
              class="list" 
              handle=".handle"
              @end="updateSorted()">
            <template #item="{ element }">
              <tr>
                <td scope="row"><i class="fa fa-align-justify handle"></i> {{ element.name }}</td>
                <td>
                  <badge class="mr-4" :type="itemType(element)">
                    <span class="status">{{ itemTypeStr(element) }}</span>
                  </badge>
                </td>
                <td>{{element.device.name}}</td>
                <td class="text-right">
                  <button v-if="element.enabled" class="btn btn-danger btn-sm"  @click="disabledItem(element)">Disable</button>
                  <button v-if="!element.enabled" class="btn btn-success btn-sm" @click="enabledItem(element)">Enable</button>
                  <button class="btn btn-icon btn-primary btn-sm" @click="showEditModal(element)">
                    <span class="btn-inner--icon"><i class="fa fa-edit"></i></span>
                    <span class="btn-inner--text">Edit</span>
                  </button>
                </td>
              </tr>
            </template>
          </draggable>
      </table>
    </div>

     <modal v-model:show="showModal">
      <template v-slot:header>
          <h5 class="modal-title" v-if="item.id">Update experiment</h5>
          <h5 class="modal-title" v-if="!item.id">add experiment</h5>
      </template>
      <form id=item-form role="form" @submit.prevent="handleForm(!v$.$invalid)" novalidate>
        <div class="form_group">
          <label for="item_name" class="form-label">Experiment</label>
          <base-input 
              id="item_name"
              placeholder="Experiment"
              v-model="v$.item.name.$model"
              :valid="isValid(v$.item.name)"
              focused
              required></base-input>
        </div>
        <div class="form-group">
          <label for="item_group">Instrument</label>
          <select id="item_group" class="form-control" v-model="v$.item.device.$model">
            <option v-for="device in devices" :key="device.id" v-bind:value="device['@id']">{{device.name}}</option> 
          </select>
        </div>
        <div class="form_group mt-3">
          <label for="item_message" class="form-label">Status</label>
          <div>
            <base-switch v-model="v$.item.enabled.$model"></base-switch>
          </div>
        </div>
      </form>
      <template v-slot:footer>
          <base-button type="secondary" @click="showModal = false">Cancel</base-button>
          <base-button nativeType="submit" type="primary" form="item-form">Save</base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import moment from 'moment';
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import draggable from "vuedraggable";

export default {
  name: "experiences-table",
  setup: () => ({ v$: useVuelidate() }),
  components: {
    draggable
  }, 
  created() {
		this.reloadData();
    this.$resources.devices.list().then(response => (this.devices = response.data));
	},
  data() {
    return {
      items: [],
      showModal: false,
      item: {},
      isSubmitted: false,
      successMessage: false,
      devices: [] 
    };
  },
  validations() {
    return {
        item: {
            name: {required},
            device: {required},  
            enabled: {}
        } 
    } 
  },
  methods:{
    reloadData() {
      this.$resources.experiences
        .list()
        .then(response => (this.items = response.data));   
    },
    itemType(item) { 
      return item.enabled ? 'success' : 'danger';
    } ,
    itemTypeStr(item) {
      return item.enabled ? 'On' : 'Off';
    },
    dateFormat(date) {
      return moment(String(date)).format('L LTS');
    },
    showEditModal(item) {
      this.isSubmitted = false;
      this.showModal = true;      
      this.item = {...item};
      this.item.device = this.item.device['@id']; 
    },
    showCreateModal() {
      this.isSubmitted = false;
      this.showModal = true;
      this.item = {
        enabled: true
      };
    },
    isValid(item){
        if (!this.isSubmitted){
          return null;
        } 

        return !item.$invalid;
    },
    handleForm(isValid) {
      this.isSubmitted = true;

      if (!isValid) return;

      this.saveItem(this.item, true);
    },
    saveItem(item, showAlert){
      if (item.id) {
          this.$resources.experiences.update(item.id, item).then( (data) => {
              this.reloadData();
              
              showAlert && (this.successMessage = true);
              this.items[this.findIndexById(item.id)] = data;

              this.showModal = false; 
              this.item = {};

          });
      } else {
          this.item.position = this.items.length + 1;
          this.$resources.experiences.create(this.item).then( () => {
              showAlert && (this.successMessage = true);

              this.showModal = false;
              this.item = {};
              this.reloadData();
          });
      }
    },
    enabledItem(item) {
        let data = {...item};
        data.device = item.device['@id'];
        data.enabled = true;

        this.saveItem(data, false);
    },
    disabledItem(item) {
        let data = {...item};
        data.device = item.device['@id'];
        data.enabled = false;

        this.saveItem(data, false);
    }, 
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].id === id) {
              index = i;
              break;
          }
      }
      return index;
    },
    updateSorted() {
      for (let i = 0; i<this.items.length;i++) {
        this.items[i].position = i;

        let data = {...this.items[i]};
        data.device = data.device['@id'];
        this.$resources.experiences.update(this.items[i].id, data);
      }
    }
  }
};
</script>
<style>
.handle {
  cursor: move;
} 
</style>
